module.exports = __webpack_public_path__ + "static/media/bus-icon.465fee58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/bus-icon.svg
// module id = 769
// module chunks = 0